import { render, staticRenderFns } from "./ProfilingMini.vue?vue&type=template&id=52e2baca&scoped=true"
import script from "./ProfilingMini.vue?vue&type=script&lang=js"
export * from "./ProfilingMini.vue?vue&type=script&lang=js"
import style0 from "./ProfilingMini.vue?vue&type=style&index=0&id=52e2baca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e2baca",
  null
  
)

export default component.exports